import React from 'react'
import { useEffect, useState } from 'react'
import { InputText, Btn, CustomModal } from '../../../../components'

const ModalGrupoProduto = ({ incomeGrupo = null, onResponse }) => {
  // Hook
  const [grupo, setGrupo] = useState(null)
  useEffect(() => {
    incomeGrupo && setGrupo(incomeGrupo)
  }, [incomeGrupo])

  // Events

  // Render
  return (
    <CustomModal
      header={grupo && grupo.id ? 'Editando Grupo de Produtos' : 'Novo Grupo de Produtos'}
      isVisible={incomeGrupo !== null}
      onClose={() => onResponse('CLOSE')}
    >
      <div className="p-row">
        <div className="p-col-12">
          <InputText
            marginTop={0}
            label="Grupo de Produtos"
            value={grupo ? grupo.nome : ''}
            onChange={value => setGrupo({ ...grupo, nome: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => onResponse('SALVAR', { ...grupo })}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default ModalGrupoProduto
